import autosize from 'autosize';
import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    autosize(document.querySelectorAll('[data-autosize="true"]'));
  }
}
